import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileVideo } from '@fortawesome/free-solid-svg-icons';


const ModuleFragment = ({ onCourseClick }) => {

    const getDefaultDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = '10';
        const minutes = '00';

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const getDefaultDateTimeMonth = () => {
        const now = new Date();
        const year = now.getFullYear() + 1;
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = '10';
        const minutes = '01';

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const [imageUrls, setImageUrls] = useState([]);
    const [courseThumb, setCourseThumb] = useState([]);
    const [courses, setCourses] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        company: '',
        userID: localStorage.getItem('userId'), // Assuming you have the userID
        thumbnail: null,
        selectedThumb: '',
        videosWithQuizzes: []
    });
    const [categoryQuiz, setCategoryQuiz] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [isList, setIsList] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(7);
    const [searchQuery, setSearchQuery] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchCompanies();
        fetchThumbnails();
        fetchMaterials();
        fetchCategoryQuiz();
    }, []);

    useEffect(() => {
        fetchCourses(currentPage);
    }, [currentPage, itemsPerPage, selectedCompany, selectedCategory, searchQuery]); // Add formData.company to the dependencies




    const fetchMaterials = async (currentPage) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            let apiUrl = `https://beiguru.co.in/admin/materials?page=1&limit=100000`;
            // if (selectedType) {
            //     apiUrl += `&type=${selectedType}`;
            // }
            const response = await fetch(apiUrl, requestOptions);
            if (response.status === 401) {
                localStorage.clear();
                window.location.reload();
                return;
            }
            const data = await response.json();
            setCourseThumb(data.materials);
        } catch (error) {
            console.error(error);
        }
    };


    const fetchThumbnails = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            let apiUrl = `https://beiguru.co.in/admin/thumbnails`;
            const response = await fetch(apiUrl, requestOptions);
            if (response.status === 401) {
                localStorage.clear();
                window.location.reload();
                return;
            }
            const data = await response.json();
            setImageUrls(data.thumbnail);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategoryQuiz = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categoryQuiz", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => {
                    setCategoryQuiz(result);
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCourses = async (page) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/courses?page=${page}&limit=${itemsPerPage}`;
        if (selectedCompany) {
            apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
        }
        if (searchQuery) {
            apiUrl += `&searchQuery=${searchQuery}`; // Append search query
        }
        fetch(apiUrl, requestOptions)
            .then(response => {
                if (response.status === 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json();
                }
            })
            .then(result => {
                setCourses(result.courses);
                setTotalPages(result.totalPages);
                setCurrentPage(result.currentPage);
            })
            .catch(error => console.error(error));
    };

    const fetchCompanies = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/companies", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setCompanies(result))
            .catch((error) => console.error(error));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            var isPngOrJpg = true;
            if (formData.thumbnail) {
                const fileName = formData.thumbnail.name;
                isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
            }

            if (isPngOrJpg) {

                const scheduleDate = new Date(formData.schedule);
                const dueDate = new Date(formData.dueDate);
                if (dueDate && scheduleDate > dueDate) {
                    alert('Schedule date cannot be after the due date.');
                }
                else {

                    setIsLoading(true);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", localStorage.getItem('token'));
                    const formdata = new FormData();
                    if (formData.thumbnail) {
                        formdata.append("thumbnail", formData.thumbnail, formData.thumbnail.name);
                    }
                    formdata.append("company", formData.company);
                    formdata.append("userID", localStorage.getItem('userId'));
                    formdata.append("selectedThumb", formData.selectedThumb);
                    formdata.append("title", formData.title);
                    formdata.append("description", formData.description);
                    formdata.append("videosWithQuizzes", JSON.stringify(formData.videosWithQuizzes));
                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: formdata,
                        redirect: "follow"
                    };
                    const logoResponse = await fetch("https://beiguru.co.in/admin/courses", requestOptions);

                    if (!logoResponse.ok) {
                        alert('Failed to create course, please try again!!');
                        throw new Error('Failed to upload logo');
                    }

                    setFormData({
                        title: '',
                        description: '',
                        company: '',
                        userID: localStorage.getItem('userId'), // Assuming you have the userID
                        thumbnail: null,
                        selectedThumb: null,
                        videosWithQuizzes: []
                    });
                    alert('Course created successfully!!');
                    await fetchCourses();
                    setIsLoading(false);
                    setIsList(true);
                }
            } else {
                alert('Thumbnail can only contain png or jpg.');
            }
        } catch (error) {
            console.log(error);
            alert('Failed to create course, please try again!!');
            setIsLoading(false);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            var isPngOrJpg = true;
            if (formData.thumbnail) {
                const fileName = formData.thumbnail.name;
                isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
            }

            if (isPngOrJpg) {
                const scheduleDate = new Date(formData.schedule);
                const dueDate = new Date(formData.dueDate);
                if (dueDate && scheduleDate > dueDate) {
                    alert('Schedule date cannot be after the due date.');
                }
                else {
                    setIsLoading(true);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", localStorage.getItem('token'));
                    const formdata = new FormData();
                    if (formData.thumbnail) {
                        formdata.append("thumbnail", formData.thumbnail, formData.thumbnail.name);
                    }
                    formdata.append("company", formData.company);
                    formdata.append("userID", localStorage.getItem('userId'));
                    formdata.append("selectedThumb", formData.selectedThumb);
                    formdata.append("title", formData.title);
                    formdata.append("description", formData.description);
                    formdata.append("videosWithQuizzes", JSON.stringify(formData.videosWithQuizzes));

                    const requestOptions = {
                        method: "PUT",
                        headers: myHeaders,
                        body: formdata,
                        redirect: "follow"
                    };
                    const response = await fetch(`https://beiguru.co.in/admin/courses/${formData.courseIdToUpdate}`, requestOptions);
                    if (!response.ok) {
                        throw new Error('Failed to update course');
                    }
                    setFormData({
                        title: '',
                        description: '',
                        company: '',
                        userID: localStorage.getItem('userId'), // Assuming you have the userID
                        thumbnail: null,
                        selectedThumb: null,
                        videosWithQuizzes: []
                    });
                    alert('Course updated successfully!');
                    await fetchCourses();
                    setIsEdit(false);
                    setIsLoading(false);
                    setIsList(true);
                }
            } else {
                alert('Thumbnail can only contain png or jpg.');
            }
        } catch (error) {
            alert('Failed to update course, please try again!');
            setIsLoading(false);
        }
    };


    const handleFileChange = (e) => {
        if (e.target.files[0].name.includes('png') || e.target.files[0].name.includes('jpg')) {
            setFormData({ ...formData, thumbnail: e.target.files[0] });
        }
    };

    const handleConsentFile = (e) => {
        setFormData({ ...formData, consentFile: e.target.files[0] });
    };

    const handleEdit = (course) => {
        const now = new Date(course.schedule);
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours() - 5).padStart(2, '0');
        const minutes = String(now.getMinutes() - 30).padStart(2, '0');
        setFormData({
            courseIdToUpdate: course._id,
            title: course.title,
            description: course.description,
            company: course.company._id,
            courseIdToUpdate: course._id, // Set courseIdToUpdate to the ID of the course being edited
            videosWithQuizzes: course.videosWithQuizzes.map((material) => {
                return {
                    video: material.video,
                    quiz: material.quiz.map(question => ({
                        question: question.question,
                        options: question.options,
                        custom: question.custom,
                        category: question.category,
                        correctAnswer: question.isMCQ
                            ? question.options.indexOf(question.correctAnswer)
                            : question.correctAnswer ? question.correctAnswer.includes(',')
                                ? question.correctAnswer.split(',').map(numString => parseInt(numString, 10)) : ''
                                : '',
                        questionType: question.isMCQ ? 'MCQ' : question.correctAnswer ? question.correctAnswer.includes(',')
                            ? 'single' : 'Assessment'
                            : 'Assessment',
                        notes: question.notes,
                    }))
                }
            }),
        });
        setIsEdit(true);
        setIsList(false);
    };

    const handleDelete = async (courseId) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to delete this course?");
        if (!isConfirmed) return; // If user cancels, do nothing

        try {
            const token = localStorage.getItem('token'); // Get the authentication token
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': token },
            };

            const response = await fetch(`https://beiguru.co.in/course/${courseId}`, requestOptions);

            if (response.ok) {
                alert('Course deleted successfully');
                fetchCourses(currentPage);
            } else {
                alert('Failed to delete course');
            }
        } catch (error) {
            console.error('Error deleting course:', error);
            alert('Failed to delete course');
        }
    };

    function capitalizeFirstLetter(string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const filteredThumbnails = courseThumb
        .filter(e => e.type === formData.type)
        .filter(url => url.title.toLowerCase().includes(searchTerm.toLowerCase()));


    return (
        <Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <Container fluid style={{ height: '100%' }}>
                <Row>
                    {isList ? <Col xs={12} style={{ height: '90vh', overflowY: 'scroll', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'start' }}>
                        <div style={{ display: 'flex', width: '100%', flexDirection: 'row', marginBottom: '10px' }}>
                            <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '10px' }}
                                    as="select"
                                    value={selectedCompany}
                                    onChange={(e) => {
                                        setSelectedCompany(e.target.value);
                                        setCurrentPage(1);
                                    }}>
                                    <option value="">All Organizations</option>
                                    {companies.map(company => (
                                        <option key={company._id} value={company._id}>{company.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Control
                                style={{ borderRadius: '10px', flex: 1, marginLeft: '10px' }}
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <Button
                                variant="outline-primary"
                                style={{ borderRadius: '10px', marginLeft: '10px', }}
                                elevation={3}>
                                <CSVLink
                                    data={courses.map(course => ({
                                        Thumbnail: course.thumbnail,
                                        Title: course.title,
                                        Description: course.description,
                                        Organization: course.type != 'demo' ? course.company.name : 'Demo'
                                    }))} // Pass your students data here
                                    filename={"courses.csv"}
                                    target="_blank"
                                >
                                    Download CSV
                                </CSVLink>

                            </Button>
                            <Button
                                style={{ fontWeight: '600', borderRadius: '10px', marginLeft: '10px', }}
                                elevation={3}
                                className="w-10"
                                variant="primary"
                                type="submit"
                                disabled={isLoading}
                                onClick={(event) => {
                                    event.preventDefault();
                                    setFormData({
                                        title: '',
                                        description: '',
                                        company: '',
                                        userID: localStorage.getItem('userId'), // Assuming you have the userID
                                        thumbnail: null,
                                        selectedThumb: null,
                                        videosWithQuizzes: []
                                    });
                                    setIsEdit(false);
                                    setIsList(!isList);
                                }}>
                                {isList ? 'Create Module' : 'Cancel'}
                            </Button>
                        </div>
                        {courses.length > 0 ? <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Thumbnail</th>
                                    <th>Title/Description</th>
                                    <th>Organization</th>
                                    <th>No Of Materials</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Map through courses data to display each course */}
                                {courses.map(course => (
                                    <tr key={course._id}>

                                        <td style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }} onClick={() => {
                                            onCourseClick(course.company._id, course._id);
                                        }}>
                                            <img
                                                src={`https://beiguru.co.in/${course.thumbnail}`}
                                                height="50"
                                                className="d-inline-block align-center"
                                                alt="Thumbnail"
                                            />
                                        </td>
                                        <td onClick={() => {
                                            onCourseClick(course.company._id, course._id);
                                        }}>
                                            {course.title}
                                            <p style={{ margin: '0px', padding: '0px', fontSize: '12px', maxHeight: '2.4em', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2em' }}>{course.description}</p>
                                        </td>
                                        <td onClick={() => {
                                            onCourseClick(course.company._id, course._id);
                                        }}>
                                            <p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>{course.type != 'demo' ? course.company.name : 'Demo'}</p>
                                        </td>
                                        {/* <td onClick={() => {
                                            onCourseClick(course.company._id, course._id);
                                        }}>
                                            <p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>{capitalizeFirstLetter(course.type)}</p>
                                        </td> */}
                                        <td onClick={() => {
                                            onCourseClick(course.company._id, course._id);
                                        }}>
                                            <p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>{course.videosWithQuizzes.length} Materials</p>
                                        </td>
                                        <td>
                                            {/* EditNoteIcon */}
                                            <EditNoteIcon onClick={(e) => {
                                                e.stopPropagation(); // Stop propagation
                                                handleEdit(course);
                                            }} style={{ color: 'green', cursor: 'pointer' }} />

                                            {/* DeleteSweepIcon */}
                                            <DeleteSweepIcon onClick={(e) => {
                                                e.stopPropagation(); // Stop propagation
                                                handleDelete(course._id);
                                            }} style={{ color: 'red', cursor: 'pointer' }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table> : <div style={{ flex: 1, textAlign: 'center' }}>No modules found, please try again!</div>}
                        <div style={{ flex: 1 }} />
                        {courses.length > 0 ? <nav aria-label="Courses pagination">
                            <ul className="pagination" style={{ display: 'flex', alignItems: 'center' }}>
                                <li className="page-item">
                                    <select
                                        className="form-select form-select-sm"
                                        aria-label="Default select example"
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setCurrentPage(1);
                                            setItemsPerPage(parseInt(e.target.value));
                                        }}
                                        style={{ height: '40px' }} // Set the height to 100%
                                    >
                                        <option value="7">7 per page</option>
                                        <option value="10">10 per page</option>
                                        <option value="50">50 per page</option>
                                        <option value="100">100 per page</option>
                                    </select>
                                </li>
                                <div style={{ width: '10px' }} />
                                {[...Array(totalPages).keys()].map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav> : null}
                    </Col> : <Col xs={12} style={{ height: '90vh', overflowY: 'scroll', }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <h4>{isEdit ? 'Edit' : 'Create'} Module</h4>
                            <Button variant="secondary" onClick={() => {
                                setFormData({
                                    title: '',
                                    description: '',
                                    company: '',
                                    userID: localStorage.getItem('userId'), // Assuming you have the userID
                                    thumbnail: null,
                                    selectedThumb: null,
                                    videosWithQuizzes: []
                                })
                                setIsEdit(!isEdit);
                                setIsList(!isList);
                            }}>Cancel</Button>
                        </div>
                        <Row xs={12}>
                            <Col xs={6}>
                                <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                                    {formData.type == 'demo' ? null : <Form.Group controlId="formCompany">
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Organization<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            className="w-100"
                                            style={{ width: '100%', borderRadius: '20px' }}
                                            as="select"
                                            value={formData.company}
                                            onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                                        >
                                            <option value="">Select a organization</option>
                                            {companies.map(company => (
                                                <option key={company._id} value={company._id}>{company.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>}
                                    <Form.Group controlId="formCourseTitle">
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Title<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            className="w-100"
                                            style={{ width: '100%', borderRadius: '20px' }} type="text"
                                            placeholder="Enter module title"
                                            value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formCourseDescription">
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Description<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            className="w-100"
                                            maxLength={70}
                                            style={{ width: '100%', borderRadius: '20px' }}
                                            as="textarea" rows={3} placeholder="Enter course description"
                                            value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                        />
                                        <p style={{ color: 'grey', fontSize: '12px' }}>{formData.description.length}/70</p> {/* Display character count */}
                                    </Form.Group>
                                    {/* <Form.Group controlId="dueDate">
                                        <Form.Label>Due Date:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={formData.dueDate}
                                            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                                            required
                                            style={{ marginBottom: '10px' }}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="scheduleDate">
                                        <Form.Label>Schedule Course:</Form.Label>
                                        <Form.Control
                                            type="datetime-local"
                                            value={formData.schedule}
                                            onChange={(e) => setFormData({ ...formData, schedule: e.target.value })}
                                            required
                                            style={{ marginBottom: '10px' }}
                                        />
                                    </Form.Group> */}
                                    {/* {formData.type == 'compliance' ? <Form.Group controlId="formShowConsentForm" style={{ flexDirection: 'row', display: 'flex' }}>
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px', }}>Show Consent Form: </Form.Label>
                                        <div style={{ margin: '10px' }} />
                                        <Form.Check
                                            type="radio"
                                            label="Yes"
                                            name="showConsentForm"
                                            value="yes"
                                            checked={formData.showConsentForm === "yes"}
                                            onChange={(e) => setFormData({ ...formData, showConsentForm: e.target.value })}
                                        />
                                        <div style={{ margin: '10px' }} />
                                        <Form.Check
                                            type="radio"
                                            label="No"
                                            name="showConsentForm"
                                            value="no"
                                            checked={formData.showConsentForm === "no"}
                                            onChange={(e) => setFormData({ ...formData, showConsentForm: e.target.value })}
                                        />
                                    </Form.Group> : <div />} */}
                                    {/* {formData.showConsentForm == 'yes' && formData.type == 'compliance' ? <Form.Group controlId="formCourseTitle">
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Title</Form.Label>
                                        <Form.Control
                                            className="w-100"
                                            style={{ width: '100%', borderRadius: '20px' }} type="text"
                                            placeholder="Enter consent text"
                                            value={formData.consentText} onChange={(e) => setFormData({ ...formData, consentText: e.target.value })}
                                        />
                                    </Form.Group> : null}
                                    {formData.showConsentForm == 'yes' && formData.type == 'compliance' ? <Form.Group controlId="formCourseConsent" style={{ marginTop: '10px', }}>
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Upload Consent Document</Form.Label>
                                        <Form.Control type="file" className="w-100"
                                            placeholder="Select Consent Document"
                                            onChange={handleConsentFile}
                                            accept=".pdf"
                                            style={{ width: '100%', borderRadius: '20px' }} />
                                    </Form.Group> : null} */}
                                </Form>
                                <Button style={{ fontWeight: '600', borderRadius: '20px', marginTop: '15px', marginBottom: '10px' }}
                                    elevation={3}
                                    className="w-100"
                                    variant="primary" type="submit"
                                    onClick={isEdit ? handleUpdate : handleSubmit}
                                    disabled={isLoading}>
                                    {isLoading ? <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : null}
                                    {isEdit ? 'Edit' : 'Create'} Module
                                </Button>
                            </Col>
                            <Col xs={6} style={{ height: '90vh', overflowY: 'scroll', marginBottom: '10px' }}>
                                {isLoading ? null : <Form.Group controlId="formCourseThumbnail" style={{ marginTop: '10px', }}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Upload Thumbnail<span style={{ color: 'red' }}> *</span></Form.Label>
                                    <Form.Control type="file" className="w-100"
                                        placeholder="Select Thumbnail"
                                        onChange={handleFileChange}
                                        accept=".png,.jpg,.jpeg"
                                        style={{ width: '100%', borderRadius: '20px' }} />
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px', fontSize: '12px' }}>* If thumbnail is uploaded default will be overridden.</Form.Label>
                                </Form.Group>}
                                {/* <div style={{ alignItems: 'center', display: 'flex', width: '100%', flexDirection: 'column' }}>
                                    <Form.Group controlId="formCourseThumbnail" style={{ marginTop: '10px', fontFamily: 'Dosis', }}><Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>OR</Form.Label></Form.Group>
                                </div>
                                <Form.Group controlId="formCourseThumbnail"><Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Select from one of these:</Form.Label></Form.Group>
                                <Container fluid>
                                    <Row noGutters className="flex-nowrap overflow-auto">
                                        {imageUrls.filter((e) => e.type == formData.type).map((url, index) => (
                                            <Col key={index} className="mb-1" style={{ borderRadius: '5px', minWidth: '150px', padding: '2.5px', backgroundColor: formData.selectedThumb === url.thumbnail ? 'blue' : 'transparent', maxWidth: '160px', flex: '0 0 auto' }}>
                                                <img
                                                    src={'https://beiguru.co.in/' + url.thumbnail}
                                                    alt={`Image ${index + 1}`}
                                                    className={`img-fluid`}
                                                    style={{ borderRadius: '5px', }}
                                                    onClick={() => {
                                                        setFormData({ ...formData, selectedThumb: url.thumbnail });
                                                    }}
                                                />
                                            </Col>
                                        ))
                                        }
                                    </Row>
                                </Container> */}
                                <Form.Group controlId="formCourseThumbnail">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px', marginTop: '10px' }}>Select module material (Multiple allowed)<span style={{ color: 'red' }}> *</span>:</Form.Label>
                                    <Container fluid>
                                        <Form.Group controlId="search">
                                            <Form.Control
                                                type="text"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                placeholder="Search by title..."
                                                style={{ marginBottom: '10px' }}
                                            />
                                        </Form.Group>
                                        <Row noGutters className="flex-nowrap overflow-auto">
                                            {filteredThumbnails.map((url, index) => (
                                                <Col
                                                    key={index}
                                                    className="mb-1"
                                                    style={{
                                                        borderRadius: '5px',
                                                        minWidth: '150px',
                                                        padding: '2.5px',
                                                        backgroundColor: formData.videosWithQuizzes.some(e => e._id === url.videosWithQuizzes[0]._id || e.video.title === url.videosWithQuizzes[0].video.title) ? 'blue' : 'transparent',
                                                        maxWidth: '160px',
                                                        flex: '0 0 auto',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    <img
                                                        src={'https://beiguru.co.in/' + url.thumbnail}
                                                        alt={`Image ${index + 1}`}
                                                        className="img-fluid"
                                                        style={{ borderRadius: '5px' }}
                                                        onClick={() => {
                                                            if (formData.videosWithQuizzes.some(e => e._id === url.videosWithQuizzes[0]._id || e.video.title === url.videosWithQuizzes[0].video.title)) {
                                                                setFormData({
                                                                    ...formData,
                                                                    videosWithQuizzes: formData.videosWithQuizzes.filter(imageUrl => {
                                                                        if (imageUrl._id) {
                                                                            return imageUrl._id !== url.videosWithQuizzes[0]._id;
                                                                        } else {
                                                                            return imageUrl.video.title !== url.videosWithQuizzes[0].video.title
                                                                        }
                                                                    })
                                                                });
                                                            } else {
                                                                if (!url.videosWithQuizzes[0].isEdit) {
                                                                    url.videosWithQuizzes[0].isEdit = true;
                                                                    url.videosWithQuizzes[0].quiz = url.videosWithQuizzes[0].quiz.map(question => ({
                                                                        question: question.question,
                                                                        options: question.options,
                                                                        category: question.category,
                                                                        correctAnswer: question.isMCQ
                                                                            ? question.options.indexOf(question.correctAnswer)
                                                                            : question.correctAnswer ? question.correctAnswer.includes(',')
                                                                                ? question.correctAnswer.split(',').map(numString => parseInt(numString, 10)) : ''
                                                                                : '',
                                                                        questionType: question.isMCQ ? 'MCQ' : question.correctAnswer ? question.correctAnswer.includes(',')
                                                                            ? 'single' : 'Assessment'
                                                                            : 'Assessment',
                                                                        notes: question.notes,
                                                                    }));
                                                                }
                                                                setFormData({
                                                                    ...formData,
                                                                    videosWithQuizzes: [...formData.videosWithQuizzes, url.videosWithQuizzes[0]]
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    <Form.Label style={{ fontWeight: '500', color: formData.videosWithQuizzes.some(e => e._id === url.videosWithQuizzes[0]._id || e.video.title === url.videosWithQuizzes[0].video.title) ? 'white' : 'black', borderRadius: '20px', fontSize: '12px' }}>{url.title}</Form.Label>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Container>
                                </Form.Group>
                                {formData.videosWithQuizzes.map((material, materialIndex) => {
                                    return <div style={{ backgroundColor: '#F9F9F9', borderRadius: '5px', marginTop: '10px' }}>
                                        <div style={{ height: '10px' }} />
                                        <h6 style={{ fontWeight: '500', borderRadius: '20px', alignSelf: 'center', marginTop: '10px', marginLeft: '10px' }}>Material {materialIndex + 1}</h6>
                                        <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <img
                                                src={`https://beiguru.co.in/${material.video.thumbnail}`}
                                                height="100"
                                                className="d-inline-block align-center"
                                                alt="Logo"
                                            />
                                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px', marginRight: '10px', fontSize: '16px', }}>
                                                {material.video.title}<p style={{ margin: '0px', padding: '0px', fontSize: '14px', maxHeight: '2.4em', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2em' }}>
                                                    {material.video.description}</p>
                                            </div>
                                            {material.video.isVideo ? (
                                                <FontAwesomeIcon icon={faFileVideo} />
                                            ) : (
                                                <FontAwesomeIcon icon={faFilePdf} />
                                            )}
                                        </div>
                                        {material.quiz.map((question, questionIndex) => {
                                            return <div key={questionIndex} style={{ backgroundColor: '#F3F3F3', marginBottom: '10px', padding: '10px', borderRadius: '5px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' }}>
                                                    <h6 style={{ fontWeight: '500', borderRadius: '20px', alignSelf: 'center' }}>Question {questionIndex + 1}</h6>
                                                    {question.custom ? <DeleteSweepIcon onClick={() => {
                                                        const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                        newQuestions.splice(questionIndex, 1); // Remove question
                                                        setFormData(prevState => {
                                                            const updatedQuestions = [...prevState.videosWithQuizzes];
                                                            updatedQuestions[materialIndex].quiz = newQuestions;
                                                            return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                        });
                                                    }} style={{ color: 'red', cursor: 'pointer' }} /> : null}
                                                </div>
                                                <Form.Group controlId={`formCategory${questionIndex}`}>
                                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category</Form.Label>
                                                    <Form.Control
                                                        className="w-100"
                                                        style={{ width: '100%', borderRadius: '20px' }}
                                                        as="select"
                                                        disabled={!question.custom}
                                                        value={question.category}
                                                        onChange={(e) => {
                                                            const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                            newQuestions[questionIndex].category = e.target.value;
                                                            setFormData(prevState => {
                                                                const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                updatedQuestions[materialIndex].quiz = newQuestions;
                                                                return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                            });
                                                        }}>
                                                        <option value="">Select a category</option>
                                                        {categoryQuiz.map(category => (
                                                            <option key={category._id} value={category._id}>{category.name}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group controlId={`formQuestionType${questionIndex}`} disabled={true}>
                                                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
                                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px', margin: '0px', padding: '0px' }}>Question Type:</Form.Label>
                                                        <div style={{ width: '10px' }} />
                                                        <Form.Check
                                                            type="radio"
                                                            label="MCQ"
                                                            disabled={!question.custom}
                                                            checked={question.questionType === 'MCQ'}
                                                            onChange={(e) => {
                                                                const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                newQuestions[questionIndex].questionType = 'MCQ';
                                                                newQuestions[questionIndex].correctAnswer = 0;
                                                                newQuestions[questionIndex].options = [...Array(4)]
                                                                setFormData(prevState => {
                                                                    const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                    updatedQuestions[materialIndex].quiz = newQuestions;
                                                                    return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                });
                                                            }}
                                                        />
                                                        <div style={{ width: '10px' }} />
                                                        <Form.Check
                                                            type="radio"
                                                            label="Single"
                                                            disabled={!question.custom}
                                                            checked={question.questionType === 'single'}
                                                            onChange={(e) => {
                                                                const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                newQuestions[questionIndex].questionType = 'single';
                                                                newQuestions[questionIndex].correctAnswer = [];
                                                                newQuestions[questionIndex].options = [...Array(4)]
                                                                setFormData(prevState => {
                                                                    const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                    updatedQuestions[materialIndex].quiz = newQuestions;
                                                                    return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                });
                                                            }}
                                                        />
                                                        <div style={{ width: '10px' }} />
                                                        <Form.Check
                                                            type="radio"
                                                            label="Assessment"
                                                            disabled={!question.custom}
                                                            checked={question.questionType === 'Assessment'}
                                                            onChange={(e) => {
                                                                const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                newQuestions[questionIndex].questionType = 'Assessment';
                                                                newQuestions[questionIndex].correctAnswer = '';
                                                                newQuestions[questionIndex].options = [...Array(4)]
                                                                setFormData(prevState => {
                                                                    const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                    updatedQuestions[materialIndex].quiz = newQuestions;
                                                                    return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Form.Group controlId="formQuestion">
                                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Question</Form.Label>
                                                    <Form.Control
                                                        className="w-100"
                                                        style={{ width: '100%', borderRadius: '20px' }}
                                                        type="text"
                                                        as="textarea" rows={2}
                                                        placeholder="Enter the question"
                                                        value={question.question}
                                                        onChange={(e) => {
                                                            const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                            newQuestions[questionIndex].question = e.target.value;
                                                            setFormData(prevState => {
                                                                const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                updatedQuestions[materialIndex].quiz = newQuestions;
                                                                return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>
                                                {question.questionType === 'MCQ' && (
                                                    <div>
                                                        <Form.Group controlId={`formOptions${questionIndex}`}>
                                                            <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Options</Form.Label>
                                                            {question.options.map((option, index) => (
                                                                <div key={index} className="mb-3" style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                                                    <Form.Check
                                                                        type="radio"
                                                                        id={`option${index}`}
                                                                        disabled={!question.custom}
                                                                        name={`correctAnswer${questionIndex}`}
                                                                        value={index}
                                                                        checked={question.correctAnswer === index}
                                                                        onChange={(e) => {
                                                                            const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                            newQuestions[questionIndex].correctAnswer = index;
                                                                            setFormData(prevState => {
                                                                                const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                                updatedQuestions[materialIndex].quiz = newQuestions;
                                                                                return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                            });
                                                                        }}
                                                                    />
                                                                    <div style={{ width: '10px' }} />
                                                                    <Form.Control
                                                                        className="w-100"
                                                                        style={{ width: '100%', borderRadius: '20px' }}
                                                                        type="text"
                                                                        disabled={!question.custom}
                                                                        value={option}
                                                                        placeholder={`Option ${index + 1}`}
                                                                        onChange={(e) => {
                                                                            const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                            const newOptions = [...question.options];
                                                                            newOptions[index] = e.target.value;
                                                                            newQuestions[questionIndex].options = newOptions;
                                                                            setFormData(prevState => {
                                                                                const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                                updatedQuestions[materialIndex].quiz = newQuestions;
                                                                                return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </Form.Group>
                                                    </div>
                                                )}
                                                {question.questionType === 'single' && (<div>
                                                    <Form.Group controlId={`formOptions${questionIndex}`}>
                                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Options</Form.Label>
                                                        {question.options.map((option, index) => (
                                                            <div key={index} className="mb-3" style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                                                <Form.Check
                                                                    type="checkbox" // Change type to "checkbox"
                                                                    id={`option${index}`}
                                                                    name={`correctAnswer${questionIndex}`}
                                                                    value={index}
                                                                    disabled={!question.custom}
                                                                    checked={question.correctAnswer.includes(index)} // Check if the index is included in correctAnswer array
                                                                    onChange={() => {
                                                                        const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                        const newCorrectAnswer = question.correctAnswer.includes(index)
                                                                            ? question.correctAnswer.filter(item => item !== index)
                                                                            : [...newQuestions[questionIndex].correctAnswer, index];
                                                                        newQuestions[questionIndex].correctAnswer = newCorrectAnswer;
                                                                        setFormData(prevState => {
                                                                            const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                            updatedQuestions[materialIndex].quiz = newQuestions;
                                                                            return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                        });
                                                                    }}
                                                                />
                                                                <div style={{ width: '10px' }} />
                                                                <Form.Control
                                                                    className="w-100"
                                                                    style={{ width: '100%', borderRadius: '20px' }}
                                                                    type="text"
                                                                    disabled={!question.custom}
                                                                    placeholder={`Option ${index + 1}`}
                                                                    value={option}
                                                                    onChange={(e) => {
                                                                        const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                                        const newOptions = [...question.options];
                                                                        newOptions[index] = e.target.value;
                                                                        newQuestions[questionIndex].options = newOptions;
                                                                        setFormData(prevState => {
                                                                            const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                            updatedQuestions[materialIndex].quiz = newQuestions;
                                                                            return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Form.Group>
                                                </div>
                                                )}
                                                <Form.Group controlId="formQuestion">
                                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Notes</Form.Label>
                                                    <Form.Control
                                                        className="w-100"
                                                        style={{ width: '100%', borderRadius: '20px' }}
                                                        type="text"
                                                        as="textarea" rows={2}
                                                        disabled={!question.custom}
                                                        placeholder="Enter the notes"
                                                        value={question.notes}
                                                        onChange={(e) => {
                                                            const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                            newQuestions[questionIndex].notes = e.target.value;
                                                            setFormData(prevState => {
                                                                const updatedQuestions = [...prevState.videosWithQuizzes];
                                                                updatedQuestions[materialIndex].quiz = newQuestions;
                                                                return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>

                                            </div>
                                        })}
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            elevation={3}
                                            className="w-100"
                                            style={{ fontWeight: '600', borderRadius: '20px', marginBottom: '5px' }}
                                            onClick={() => {
                                                const newQuestions = [...formData.videosWithQuizzes[materialIndex].quiz];
                                                setFormData(prevState => {
                                                    const updatedQuestions = [...prevState.videosWithQuizzes];
                                                    updatedQuestions[materialIndex].quiz = [...newQuestions, { question: '', custom: true, options: [{ optionText: '', weightage: '' }] }];
                                                    return { ...prevState, videosWithQuizzes: updatedQuestions };
                                                });
                                            }}
                                        >
                                            Add Custom Question
                                        </Button>
                                    </div>
                                })}
                            </Col>
                        </Row>
                    </Col>}
                </Row>
            </Container >
        </Grid >
    );
}

export default ModuleFragment;